import { useSelector } from 'react-redux'
import { selectCustomerNotificationsSettings } from '@/features/domain/territory'

export function useNotificationsStatus() {
  return useSelector(selectCustomerNotificationsSettings)
}
